export function saveAdd (data) {
  return this.fetch({
    method: 'POST',
    url: 'mall-server/api/userAddress/v1/save',
    data
  })
}
// 获取地址
export function getAreasListNew (params) {
  return this.fetch({
    url: 'mall-server/api/userAddress/v1/getList',
    params
  })
}
// 设置默认地址
export function setDefaultAddr (params) {
  return this.fetch({
    url: 'mall-server/api/userAddress/v1/setDefault',
    params
  })
}
// 删除地址
export function delAddr (params) {
  return this.fetch({
    url: 'mall-server/api/userAddress/v1/delete',
    params
  })
}
export function getSiteNew (params) {
  return this.fetch({
    method: 'GET',
    url: 'mall-server/api/userAddress/v1/get',
    params
  })
}
// 地址省市区
export function getAreasNew (params) {
  return this.fetch({
    method: 'GET',
    url: 'resources/information/coocaa_region.json',
    params
  })
}
// 检查是否为不发货地区
export function checkShippingArea (data) {
  return this.fetch({
    method: 'POST',
    url: 'mall-server/api/order/v3/checkShippingArea',
    data
  })
}